import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { listProjectTechs } from '../../modules/techModule/projectTechs';
import { setTech, viewTech } from '../../modules/techModule/tech';
import { setTechRslt, viewTechRslt } from '../../modules/techModule/techRslt';
import { setTechPlan, viewTechPlan } from '../../modules/techModule/techPlan';

import * as techApi from '../../lib/api/tech';
import { listMidTechs, unloadMidTechs } from '../../modules/techModule/techMids';
import TechEditStepperModal from '../../components/techmng/support/TechEditStepperModal';


const TechEditStepperModalContainer = ({ open, handleClose, reqId }) => {
    const dispatch = useDispatch();


    const [activeStep, setActiveStep] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const { project, tech, techPlan, techMids, techMidInfo, techRslt, user, } = useSelector(({ techModule, auth }) => ({
        user: auth.user,
        project: techModule.tech.project,
        tech: techModule.tech.tech,
        techPlan: techModule.techPlan.techPlan,
        techMids: techModule.midTechs.techMids,
        techMidInfo: techModule.midTechs.techMidInfo,
        techRslt: techModule.techRslt.techRslt,
    }));

    useEffect(() => {
        if (reqId) {
            //tech 정보 가져오기
            dispatch(viewTech(reqId));
        }
    }, [reqId]);


    useEffect(() => {
        if (tech) {
            const step = parseInt(tech.reqGrade) - 1;
            const tab = getActiveTap(tech.reqGrade);
            setActiveStep(step);
            setActiveTab(tab);
        }
    }, [tech])

    const checkMidTab = (techPlan) => {
        return techPlan?.plnTyp.includes('장기') ? 2 : 3;
    }

    const getActiveTap = (grade) => {
        let tab = 0
        if (grade === "1") {
            tab = 0;
        } else if (grade === "2") {//지원확인
            tab = 1;
        } else if (grade === "3") {//작업계획
            tab = checkMidTab(techPlan);

        } else if (grade > 3) {
            tab = 3;
        }
        return tab;
    }

    useEffect(() => {
        if (tech && tech?.planUuid !== null && tech?.planUuid !== '') {
            dispatch(viewTechPlan(tech.planUuid));
            const searchData = { "reqUuid": tech?.reqUuid, "planUuid": tech?.planUuid, "prjUuid": tech?.prjUuid };
            dispatch(listMidTechs(searchData));
        }
    }, [tech])

    useEffect(() => {
        if (tech && tech?.rsltUuid !== null && tech?.rsltUuid !== '') {
            dispatch(viewTechRslt(tech.rsltUuid));
        }
    }, [tech])


    const handleTabChange = (event, newValue) => {
        // console.log(newValue, 'newValue')
        // let newStep = newValue;
        setActiveTab(newValue)
    }

    const reloadTech = async (id) => {

        try {
            const res = await techApi.getTechById(id);
            if (res.data.info) {
                dispatch(setTech(res.data.info));
            }
        } catch (err) {
            console.log(err)
        }
    }



    const onClose = () => {
        setTech(null);
        setTechPlan(null);
        setTechRslt(null);
        unloadMidTechs();
        dispatch(listProjectTechs(tech.prjUuid));
        handleClose();
    }


    if (!project || !tech) {
        return null;
    }



    return (
        <TechEditStepperModal
            open={open}
            activeStep={activeStep}
            activeTab={activeTab}
            tech={tech}
            techRslt={techRslt}
            techPlan={techPlan}
            techMids={techMids}
            techMidInfo={techMidInfo}
            project={project}
            user={user}
            handleClose={onClose}
            reloadTech={reloadTech}
            handleTabChange={handleTabChange}
        />
    )
}
export default TechEditStepperModalContainer